import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views

import Dashboard from "views/admin/Dashboard.js";
import { useSelector } from "react-redux";
import Team from "views/admin/Team";
import Blog from "views/admin/Blog";
import Faq from "views/admin/Faq";
import CreateBlog from "views/admin/CreateBlog";
import EditBlog from "views/admin/EditBlog";
import CreateFaq from "views/admin/CreateFaq";
import EditFaq from "views/admin/EditFaq";
import CreateTeam from "views/admin/CreateTeam";
import EditTeam from "views/admin/EditTeam";
import Contact from "views/admin/Contact";





export default function Admin() {
  const { access } = useSelector((state) => state.auth);

  if (!access) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/team" exact component={Team} />
            <Route exact path="/admin/team/create" component={CreateTeam} />
            <Route exact path="/admin/team/edit/:id" component={EditTeam} />
            <Route path="/admin/blogs" exact component={Blog} />
            <Route path="/admin/blog/create" component={CreateBlog} />
            <Route path="/admin/blog/edit/:id" component={EditBlog} />
            <Route path="/admin/faqs" exact component={Faq} />
            <Route exact path="/admin/faq/create" component={CreateFaq} />
            <Route exact path="/admin/faq/edit/:id" component={EditFaq} />
            <Route exact path="/admin/inquiries" component={Contact} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
